import { Splide, SplideSlide } from '@splidejs/react-splide';
import cx from 'clsx';

import communityIcon from '#/assets/static-page/community.svg';
import reliabilityIcon from '#/assets/static-page/reliability.svg';
import securityIcon from '#/assets/static-page/security.svg';

const MissionCard: React.FC<MissionCardProps> = ({ isBgBlue }) => {
  return (
    <div className="overflow-x-auto">
      <Splide options={{ arrows: false, autoWidth: true, pagination: false }}>
        <SplideSlide>
          <Card
            icon={reliabilityIcon}
            iconClassName="w-16"
            isBgBlue={isBgBlue}
            missionTitle="Reliability"
            missionDescription="We value your personal business goals and will go out of our way to fulfil them"
          />
        </SplideSlide>
        <SplideSlide>
          <Card
            icon={securityIcon}
            iconClassName="w-20"
            isBgBlue={isBgBlue}
            missionTitle="Security"
            missionDescription="We value your trust in our ability to complete the job and provide opportunities"
          />
        </SplideSlide>
        <SplideSlide>
          <Card
            icon={communityIcon}
            iconClassName="w-20"
            isBgBlue={isBgBlue}
            missionTitle="Community"
            missionDescription="We value the relationships between all the stakeholders of MOVE"
          />
        </SplideSlide>
      </Splide>
    </div>
  );
};

type MissionCardProps = {
  isBgBlue?: boolean;
};

const Card: React.FC<CardProps> = ({
  icon,
  iconClassName,
  isBgBlue,
  missionTitle,
  missionDescription,
}) => {
  return (
    <div
      className={cx(
        'flex flex-col p-10 rounded-xl gap-y-8 w-96 h-80 mr-5',
        !!isBgBlue && isBgBlue ? 'bg-blue-50' : 'bg-white',
      )}
    >
      <div className="h-20">
        <img src={icon} className={iconClassName} />
      </div>
      <div className="text-3xl text-black">{missionTitle}</div>
      <div className="text-black">{missionDescription}</div>
    </div>
  );
};

type CardProps = {
  isBgBlue?: boolean;
  icon: string;
  iconClassName: string;
  missionTitle: string;
  missionDescription: string;
};

export default MissionCard;
